import { useTranslation } from 'react-i18next';

import { PreferencesElement } from '@shared/dream-components';

import { usePreferencesContext } from '~/context/SubscriptionManagement';

/**
 * Renders the subscription preferences block on the General tab. Preferences data and every
 * mutation callback come from `PreferencesProvider` via context. Pure UI, no props, no data
 * logic.
 */
export const PreferencesSection = () => {
  const { t } = useTranslation();
  const {
    showPreferences,
    preferences,
    email,
    onSubscriptionPreferenceChange,
    onTrueFalsePreferenceChange,
    onShortResponsePreferenceChange,
    onDropdownPreferenceChange,
    onMultipleChoicePreferenceChange,
    onSingleChoicePreferenceChange,
  } = usePreferencesContext();

  if (!showPreferences) {
    return null;
  }

  return (
    <PreferencesElement
      element={{
        type: 'preferences',
        attrs: {
          data: {
            preferences: preferences,
            email: email,
          },
        },
      }}
      isLive
      translations={{
        'manage.preferences.title': t('manage.preferences.title'),
        'manage.preferences.description': t('manage.preferences.description'),
        'manage.preferences.show': t('manage.preferences.show'),
        'manage.preferences.hide': t('manage.preferences.hide'),
        'manage.preferences.subscribed': t('manage.preferences.subscribed'),
        'manage.preferences.note': t('manage.preferences.note'),
      }}
      onSubscriptionPreferenceChange={onSubscriptionPreferenceChange}
      onTrueFalsePreferenceChange={onTrueFalsePreferenceChange}
      onShortResponsePreferenceChange={onShortResponsePreferenceChange}
      onDropdownPreferenceChange={onDropdownPreferenceChange}
      onMultipleChoicePreferenceChange={onMultipleChoicePreferenceChange}
      onSingleChoicePreferenceChange={onSingleChoicePreferenceChange}
    >
      {null}
    </PreferencesElement>
  );
};
